import React from 'react';

import styles from './index.less';

const GiftRule = ({ onClick }) => (
  <button type="button" className={styles.gift_rule} onClick={onClick} aria-label="查看上线瓜分50万现金红包活动规则">
    <img src={require('./images/btn.png')} alt="" draggable={false} />
  </button>
);

export default GiftRule;
